import type { GeneratedJobOfferDraft } from "@/domains/job-offer/ai/api";
import type { AiJobOfferPayload } from "@/domains/job-offer/ai/types";

export function mapDraftToPayload(
  draft: GeneratedJobOfferDraft,
): Partial<AiJobOfferPayload> {
  const payload: Partial<AiJobOfferPayload> = {
    title: draft.title,
    description: draft.description,
    job_category: draft.job_category as AiJobOfferPayload["job_category"],
    skills: draft.skills,
    experience_level:
      draft.experience_level as AiJobOfferPayload["experience_level"],
    daily_rate_min: draft.daily_rate_min,
    daily_rate_max: draft.daily_rate_max,
    payment_type: draft.payment_type as AiJobOfferPayload["payment_type"],
    budget: draft.budget,
    effort: draft.effort as AiJobOfferPayload["effort"],
    remote_policy: draft.remote_policy as AiJobOfferPayload["remote_policy"],
    renewable: draft.renewable,
    currency: draft.currency,
    location: draft.location,
    job_subcategory: draft.job_subcategory,
  };

  if (draft.project_type) {
    payload.project_type =
      draft.project_type as AiJobOfferPayload["project_type"];
  }
  if (draft.duration) {
    payload.duration = draft.duration as AiJobOfferPayload["duration"];
  }
  if (draft.start_date) {
    payload.start_date = draft.start_date as AiJobOfferPayload["start_date"];
  }

  return payload;
}
